(function () {
  'use strict';

  var section = document.querySelector('.product-upsell');
  if (!section) return;

  var config = window.__productUpsell || {};
  var currentProduct = config.currentProduct || {};
  var variantId = section.dataset.variantId;

  var tierRadios = section.querySelectorAll('input[name="bundle-tier"]');
  var tierCards = section.querySelectorAll('.product-upsell__tier');
  var addBtn = section.querySelector('[data-add-btn]');
  var displayPrice = section.querySelector('[data-display-price]');
  var toast = section.querySelector('.product-upsell__toast');

  var _bp = config.bundlePrices || {};
  var TIERS = {
    1: { price: _bp[1] || 'CAD $59.99',  dropdowns: 0, label: '1 Bottle' },
    3: { price: _bp[3] || 'CAD $119.98', dropdowns: 3, label: 'Buy 2 Get 1 Free' },
    5: { price: _bp[5] || 'CAD $179.97', dropdowns: 5, label: 'Buy 3 Get 2 Free' }
  };

  var allProducts = [];
  var currentTier = 1;

  function fetchProducts(page, accumulated) {
    page = page || 1;
    accumulated = accumulated || [];
    var url = '/collections/all/products.json?limit=250&page=' + page;
    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.products && data.products.length > 0) {
          accumulated = accumulated.concat(data.products);
          if (data.products.length === 250) {
            return fetchProducts(page + 1, accumulated);
          }
        }
        return accumulated;
      });
  }

  function getInspiredByLabel(product) {
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags).split(',');
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i].trim().toLowerCase();
      if (tag.indexOf('inspired_by_') === 0) {
        var raw = tag.substring('inspired_by_'.length);
        var label = raw.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        if (label) return label;
      }
    }
    return product.title;
  }

  function buildCustomOption(title, inspiredBy, hasInspiredBy, index) {
    var item = document.createElement('div');
    item.className = 'mix-custom-select__option';
    item.dataset.value = title;
    item.dataset.index = index;
    var nameEl = document.createElement('div');
    nameEl.className = 'mix-custom-select__option-name';
    nameEl.textContent = title;
    item.appendChild(nameEl);
    if (hasInspiredBy) {
      var subEl = document.createElement('div');
      subEl.className = 'mix-custom-select__option-sub';
      subEl.textContent = 'Inspired by ' + inspiredBy;
      item.appendChild(subEl);
    }
    return item;
  }

  function makeCustomSelectEl() {
    var customEl = document.createElement('div');
    customEl.className = 'mix-custom-select';

    var trigger = document.createElement('div');
    trigger.className = 'mix-custom-select__trigger';
    var triggerText = document.createElement('div');
    triggerText.className = 'mix-custom-select__trigger-text';
    var placeholder = document.createElement('span');
    placeholder.className = 'mix-custom-select__placeholder';
    placeholder.textContent = 'Select a scent...';
    triggerText.appendChild(placeholder);
    var arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrowSvg.setAttribute('class', 'mix-custom-select__arrow');
    arrowSvg.setAttribute('width', '12');
    arrowSvg.setAttribute('height', '8');
    arrowSvg.setAttribute('viewBox', '0 0 12 8');
    var arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrowPath.setAttribute('d', 'M1 1.5l5 5 5-5');
    arrowPath.setAttribute('stroke', 'currentColor');
    arrowPath.setAttribute('stroke-width', '1.5');
    arrowPath.setAttribute('fill', 'none');
    arrowPath.setAttribute('stroke-linecap', 'round');
    arrowSvg.appendChild(arrowPath);
    trigger.appendChild(triggerText);
    trigger.appendChild(arrowSvg);

    var dropdown = document.createElement('div');
    dropdown.className = 'mix-custom-select__dropdown';
    var searchWrap = document.createElement('div');
    searchWrap.className = 'mix-custom-select__search';
    var searchInput = document.createElement('input');
    searchInput.className = 'mix-custom-select__search-input';
    searchInput.type = 'text';
    searchInput.placeholder = 'Search scents...';
    searchInput.setAttribute('autocomplete', 'off');
    searchWrap.appendChild(searchInput);
    dropdown.appendChild(searchWrap);

    allProducts.forEach(function (product, idx) {
      var inspiredBy = getInspiredByLabel(product);
      var hasInspiredBy = inspiredBy !== product.title;
      var item = buildCustomOption(product.title, inspiredBy, hasInspiredBy, idx);
      item.dataset.variantId = product.variants[0].id;
      dropdown.appendChild(item);
    });

    customEl.appendChild(trigger);
    customEl.appendChild(dropdown);
    return customEl;
  }

  function setupCustomSelect(customEl, hiddenSelect) {
    var trigger = customEl.querySelector('.mix-custom-select__trigger');
    var dropdown = customEl.querySelector('.mix-custom-select__dropdown');
    var triggerText = customEl.querySelector('.mix-custom-select__trigger-text');
    var searchInput = customEl.querySelector('.mix-custom-select__search-input');

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = customEl.classList.contains('open');
      section.querySelectorAll('.mix-custom-select.open').forEach(function (el) {
        el.classList.remove('open');
      });
      if (!isOpen) {
        customEl.classList.add('open');
        setTimeout(function () { searchInput.focus(); }, 50);
      }
    });

    dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      var option = e.target.closest('.mix-custom-select__option');
      if (!option) return;
      var value = option.dataset.value;
      hiddenSelect.value = value;
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (el) {
        el.classList.remove('selected');
      });
      option.classList.add('selected');
      var name = option.querySelector('.mix-custom-select__option-name').textContent;
      var subEl = option.querySelector('.mix-custom-select__option-sub');
      triggerText.innerHTML = '';
      var nameDisplay = document.createElement('div');
      nameDisplay.className = 'mix-custom-select__selected-name';
      nameDisplay.textContent = name;
      triggerText.appendChild(nameDisplay);
      if (subEl) {
        var subDisplay = document.createElement('div');
        subDisplay.className = 'mix-custom-select__selected-sub';
        subDisplay.textContent = subEl.textContent;
        triggerText.appendChild(subDisplay);
      }
      searchInput.value = '';
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (opt) {
        opt.style.display = '';
      });
      customEl.classList.remove('open');
      hiddenSelect.dispatchEvent(new Event('change'));
    });

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim().toLowerCase();
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (opt) {
        var name = opt.querySelector('.mix-custom-select__option-name').textContent.toLowerCase();
        var sub = opt.querySelector('.mix-custom-select__option-sub');
        var subText = sub ? sub.textContent.toLowerCase() : '';
        opt.style.display = (query === '' || name.indexOf(query) !== -1 || subText.indexOf(query) !== -1) ? '' : 'none';
      });
    });
  }

  function preselectCustom(customEl, title) {
    var dropdown = customEl.querySelector('.mix-custom-select__dropdown');
    var triggerText = customEl.querySelector('.mix-custom-select__trigger-text');
    var found = null;
    dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (opt) {
      if (opt.dataset.value === title) found = opt;
    });
    if (!found) return;
    found.classList.add('selected');
    var name = found.querySelector('.mix-custom-select__option-name').textContent;
    var subEl = found.querySelector('.mix-custom-select__option-sub');
    triggerText.innerHTML = '';
    var nameDisplay = document.createElement('div');
    nameDisplay.className = 'mix-custom-select__selected-name';
    nameDisplay.textContent = name;
    triggerText.appendChild(nameDisplay);
    if (subEl) {
      var subDisplay = document.createElement('div');
      subDisplay.className = 'mix-custom-select__selected-sub';
      subDisplay.textContent = subEl.textContent;
      triggerText.appendChild(subDisplay);
    }
  }

  function buildDropdowns(container, count) {
    container.innerHTML = '';
    for (var i = 0; i < count; i++) {
      (function (index) {
        var row = document.createElement('div');
        row.className = 'product-upsell__scent-row';

        var num = document.createElement('span');
        num.className = 'product-upsell__scent-num';
        num.textContent = '#' + (index + 1);

        var select = document.createElement('select');
        select.className = 'product-upsell__scent-select';
        select.dataset.scentIndex = index;
        select.style.display = 'none';

        allProducts.forEach(function (product) {
          var opt = document.createElement('option');
          opt.value = product.title;
          opt.textContent = product.title;
          opt.dataset.variantId = product.variants[0].id;
          select.appendChild(opt);
        });

        if (allProducts.length === 0) {
          var placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.disabled = true;
          placeholder.selected = true;
          select.appendChild(placeholder);
        }

        var customEl = makeCustomSelectEl();
        setupCustomSelect(customEl, select);

        if (index === 0 && currentProduct.title) {
          select.value = currentProduct.title;
          preselectCustom(customEl, currentProduct.title);
        }

        select.addEventListener('change', checkAllSelected);

        row.appendChild(num);
        row.appendChild(select);
        row.appendChild(customEl);
        container.appendChild(row);
      })(i);
    }
  }

  function checkAllSelected() {
    var activeContainer = section.querySelector('.product-upsell__tier.active [data-tier-dropdowns]');
    if (!activeContainer) {
      addBtn.disabled = false;
      return;
    }
    var selects = activeContainer.querySelectorAll('.product-upsell__scent-select');
    var allFilled = true;
    selects.forEach(function (sel) {
      if (!sel.value) allFilled = false;
    });
    addBtn.disabled = !allFilled;
  }

  function updateTier(tier) {
    currentTier = tier;

    tierCards.forEach(function (card) {
      var t = parseInt(card.dataset.tier, 10);
      var container = card.querySelector('[data-tier-dropdowns]');
      if (t === tier) {
        card.classList.add('active');
        buildDropdowns(container, TIERS[t].dropdowns);
      } else {
        card.classList.remove('active');
        container.innerHTML = '';
      }
    });

    displayPrice.textContent = TIERS[tier].price;
    checkAllSelected();
  }

  function showToast(message) {
    toast.textContent = message;
    toast.classList.add('visible');
    setTimeout(function () {
      toast.classList.remove('visible');
    }, 3000);
  }

  function refreshCartDrawer(sectionHTML) {
    if (!sectionHTML) return;
    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (!drawerInner) return;
    var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var newInner = parsed.querySelector('.drawer__inner');
    if (!newInner) return;
    drawerInner.innerHTML = newInner.innerHTML;
    if (!parsed.querySelector('cart-drawer-items.is-empty')) {
      drawerInner.classList.remove('is-empty');
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
    }
  }

  function updateCartCount(sectionHTML) {
    if (sectionHTML) {
      var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html').querySelector('.shopify-section');
      var current = document.getElementById('cart-icon-bubble');
      if (parsed && current) { current.innerHTML = parsed.innerHTML; return; }
    }
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var cartIcon = document.getElementById('cart-icon-bubble');
        var bubble = document.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubble && cartIcon) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
            cartIcon.appendChild(bubble);
          } else if (bubble) {
            var countSpan = bubble.querySelector('span[aria-hidden]');
            if (countSpan) countSpan.textContent = cart.item_count;
            bubble.classList.remove('hidden');
          }
        }
      })
      .catch(function () {});
  }

  function addToCart() {
    addBtn.classList.add('loading');
    addBtn.textContent = 'ADDING...';

    var tierInfo = TIERS[currentTier];
    var bundleLabel = tierInfo.label;

    var activeContainer = section.querySelector('.product-upsell__tier.active [data-tier-dropdowns]');
    var selects = activeContainer ? activeContainer.querySelectorAll('.product-upsell__scent-select') : [];

    var items;
    if (selects.length > 0) {
      // Aggregate ALL selected scents by variant so every qualifying bottle is
      // physically in the cart. Shopify's automatic "Signature Scents" discount
      // then applies the free bottles at checkout.
      var order = [];
      var map = {};
      selects.forEach(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        var vId = opt && opt.dataset.variantId ? parseInt(opt.dataset.variantId, 10) : null;
        if (!vId) return;
        if (!map[vId]) { map[vId] = { id: vId, quantity: 0, title: sel.value }; order.push(vId); }
        map[vId].quantity += 1;
      });
      items = order.map(function (vId) {
        var entry = map[vId];
        return { id: entry.id, quantity: entry.quantity, properties: { 'Bundle': bundleLabel, 'Scent': entry.title } };
      });
    } else {
      // Tier 1 (single bottle) uses the page product variant.
      items = [{ id: parseInt(variantId, 10), quantity: 1, properties: { 'Bundle': bundleLabel } }];
    }

    if (items.length === 0) {
      addBtn.classList.remove('loading');
      addBtn.textContent = 'ADD TO CART';
      return;
    }

    var body = { items: items, sections: 'cart-icon-bubble,cart-drawer', sections_url: window.location.pathname };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function (data) {
        showToast('\u2713 ' + tierInfo.label + ' added to cart');
        addBtn.classList.remove('loading');
        addBtn.textContent = 'ADD TO CART';
        updateCartCount(data && data.sections && data.sections['cart-icon-bubble']);
        refreshCartDrawer(data && data.sections && data.sections['cart-drawer']);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        showToast('Something went wrong. Please try again.');
        addBtn.classList.remove('loading');
        addBtn.textContent = 'ADD TO CART';
      });
  }

  document.addEventListener('click', function () {
    section.querySelectorAll('.mix-custom-select.open').forEach(function (el) {
      el.classList.remove('open');
    });
  });

  tierRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      updateTier(parseInt(this.value, 10));
    });
  });

  addBtn.addEventListener('click', function (e) {
    e.preventDefault();
    addToCart();
  });

  fetchProducts()
    .then(function (products) {
      allProducts = products;
      updateTier(1);
    })
    .catch(function (err) {
      console.error('Failed to load products:', err);
      updateTier(1);
    });
})();
